module.exports = __webpack_public_path__ + "img/image-png.4c11ea18.png";